import LogUtil from '@/core/utils/logUtil'

class HelperUtil {

    static isUndefined(item) {
        return typeof item === 'undefined';
    }

    static isObject(item) {
        return typeof item === 'object';
    }

    static isArray(item) {
        return item instanceof Array;
    }

    static isFunction(item) {
        return typeof item === 'function';
    }

    static isString(item) {
        return typeof item === 'string';
    }

    static isNumber(item) {
        return typeof item === 'number' && isFinite(item);
    }

    static isInteger(item) {
        return HelperUtil.isNumber(item) && item % 1 === 0;
    }

    static isFloat(item) {
        return HelperUtil.isNumber(item) && !HelperUtil.isInteger(item);
    }

    static forEach(item, iterator, context) {
        if (!HelperUtil.isUndefined(item) && HelperUtil.isFunction(iterator)) {
            if (HelperUtil.isArray(item)) {
                let length = item.length;
                for (let i = 0; i < length; i++) {
                    iterator.call(context, item[i], i);
                }
            } else if (HelperUtil.isObject(item)) {
                for (let key in item) {
                    iterator.call(context, item[key], key);
                }
            }
        }
    }

    static keys(item) {
        let ks: string[] = [];

        if (HelperUtil.isObject(item)) {
            for (let k in item) {
                ks.push(k);
            }
        }
        return ks;
    }

    static preventDefault(event) {
        if (event) {
            if (event.preventDefault) {
                event.preventDefault(); // Browsers
            }
            event.returnValue = false; // IE 8
        }
    }

    static getDistanceFromTo(from, to, cap) {

        let dist;

        dist = (to - from) % cap;

        if (dist !== dist % (cap / 2)) {
            dist = (dist < 0) ? dist + cap : dist - cap;
        }

        return Math.abs(dist);
    }

    static getQueryString(field, url = null, decodeURI = false) {
        let href = url ?? window.location.href,
            reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i'),
            string = reg.exec(href);
        LogUtil.log('getQueryString', href, field, string);
        if (!string) return null;
        else return decodeURI ? decodeURIComponent(string[1]) : string[1];
    }

    static roundClosestStep(value, step = 1.0) {
        // example: roundSteps(1.65125, 0.5) => 1.5
        let inv = 1.0 / step;
        return Math.round(value * inv) / inv;
    }

    static getInterval(start, end) {
        // generate an array of values within (and including) start and end.
        let numbers: number[] = [];
        for (let i = start; i <= end; i++) {
            numbers.push(i);
        }
        return numbers;
    }
}

export default HelperUtil;
